import type { MisconceptionDefinition } from './types'

import { STU_DIAGRAMMEN_MISCONCEPTIONS } from './stu/diagrammen'
import { STU_OPZOEKEN_MISCONCEPTIONS } from './stu/opzoeken'
import { STU_STUDIEVAARDIGHEDEN_MISCONCEPTIONS } from './stu/studievaardigheden'
import { STU_SCHEMAS_MISCONCEPTIONS } from './stu/schemas'

/**
 * STU — Studievaardigheden misconcepties (barrel).
 *
 * STATUS (mei 2026): **Phase B — kebab-canonical registry, barrel-split**.
 *
 * Deze barrel concateneert vier sub-registries onder `./stu/`:
 * - `diagrammen`         — diagram-keuze en -lezen (STU-DIAGRAM, STU-CIRKEL, STU-LIJN, STU-STAAF)
 * - `opzoeken`           — alfabet, woordenboek, inhoudsopgave, bibliotheek, bronnen combineren (STU-ALFABET, STU-WOORDENBOEK, STU-INHOUDSOPGAVE, STU-BIBLIOTHEEK, STU-COMBINEER)
 * - `studievaardigheden` — notities maken, samenvatten, plannen (STU-NOTITIES, STU-SAMENVATTEN, STU-PLANNEN)
 * - `schemas`            — flowchart, mindmap, kaart, route (STU-FLOWCHART, STU-MINDMAP, STU-KAART, STU-ROUTE)
 *
 * Alle IDs volgen `MISCONCEPTION_REGISTRY_SSOT_2026.md §3`: één dot tussen
 * module-prefix en kebab-case body, geen underscores, geen extra dots
 * (`stu.<sectie>-<beschrijving>`).
 *
 * Deze registry is leidend. Eventuele STU-seeds die nog naar oude
 * (Engels/underscore/dotted) tag-IDs verwijzen worden door
 * `seedConsolidator.normalizeSeedQuestion` opgepikt als unknown-tag
 * en in een latere sweep gereconcilieerd; de registry-correctheid is
 * de SSOT en gaat voor seed-compatibiliteit.
 */
export const STU_MISCONCEPTIONS: MisconceptionDefinition[] = [
  ...STU_DIAGRAMMEN_MISCONCEPTIONS,
  ...STU_OPZOEKEN_MISCONCEPTIONS,
  ...STU_STUDIEVAARDIGHEDEN_MISCONCEPTIONS,
  ...STU_SCHEMAS_MISCONCEPTIONS,
]
